import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { mapCompanyClientTags } from '../utils/clientTags';

export default function useCompanyClientTagDefinitions() {
  const { company } = useAuth();
  const companyId = company?.companyId;
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    try {
      const res = await axios.get(`/api/companies/${companyId}`);
      setTags(mapCompanyClientTags(res.data));
    } catch {
      setTags([]);
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    load();
  }, [load]);

  return { tags, loading, reload: load };
}
